import { ButtonVariant } from '@amobee/component-library';
import { Component, OnInit, Output, EventEmitter, Input, ViewChild, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ObjectType } from 'src/app/data/constants/object-type.enum';
import { PaymentType } from 'src/app/data/constants/payment-type.const';
import { Constants } from 'src/app/data/constants/constants.enum';
import { CreativeVO } from 'src/app/data/vo/CreativeVO';
import { MessageService } from 'src/app/services/message.service';
import { ModalService } from 'src/app/services/modal.service';
import { PaymentService } from '../../../../../services/payment.service';
import { environment } from 'src//environments/environment';
import * as _ from 'lodash';
import { CampaignAdapter } from 'src/adapters/campaign-adapter';
import { MiscAdapter } from 'src/adapters/misc-adapter';
import { CampaignOrder } from 'src/whiteLabel/mediaCorps/services/campaign/campaign-data';
import { IFooterProp } from 'src/app/common/components/footer/footer.component';

@Component({
  selector: 'creative-order-summary',
  templateUrl: './creative-order-summary.component.html',
  styleUrls: ['./creative-order-summary.component.scss']
})
export class CreativeOrderSummaryComponent implements OnInit {
  @Input() selectedCreatives: CreativeVO[];
  @Input() selectedVideoOptions: Array<any>;
  @Input() selectedLanguage: Array<any>;
  @Input() totalPrice: number;
  @Input() backToCampaignId: string;
  @Output("backToRenameCreative")
  backToRenameCreative: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('creativeSubmittedTemplate', { static: true }) public creativeSubmittedTemplate: TemplateRef<any>;
  @ViewChild('paymentPendingTemplate', { static: true }) public paymentPendingTemplate: TemplateRef<any>;
  paymentType: string;
  gst: number = environment.gst;
  currencySymbol: string = environment.currency;
  currencyShortSymbol: string = environment.currencySymbol;
  backingToCampaignPage: boolean = false;
  footerButtonsCreativeOrderSummary: Array<IFooterProp> = [
    {
      variant: ButtonVariant.NEUTRAL,
      label: 'Cancel',
      onClick: () => {
        this.backToList();
      },
      showIcon: () => this.backingToCampaignPage ? "Process" : null,
      iconPosition: "right",
      isDisabled: () => this.backingToCampaignPage
    },
    {
      variant: ButtonVariant.NEUTRAL,
      label: 'Back',
      onClick: () => {
        this.backToPreviousPage();
      }
    },
    {
      variant: ButtonVariant.PRIMARY,
      label: 'Complete Payment',
      onClick: () => {
        if (this.paymentType === PaymentType.CreditCard.key || this.paymentType === PaymentType.MediacorpCredit.key) {
          let selectedCreativeIds = this.selectedCreatives.map((creative) => creative.creativeId);
          this.paymentService.order(this.totalCostAfterTax, environment.currency, Constants.MEDIA, selectedCreativeIds, null, this.paymentType, null)
            .then((campaignOrder: CampaignOrder) => {
              this.setUpPaymentStatusCheck(campaignOrder.order_id);
            }).catch((err) => {
              console.log(err);
              this.modal.error({ message: 'Failed to process payment, please try again' });
            });
        } else {
          this.modal.error({ message: 'Please Select Payment type to proceed' });
        }
      }
    }
  ];
  gstAmount: any;
  totalCostAfterTax: any;
  creativeDescriptions: Array<any> = [];
  constructor(
    private router: Router,
    private paymentService: PaymentService,
    private route: ActivatedRoute,
    private modal: ModalService,
    private messageService: MessageService,
    private campaignAdapter: CampaignAdapter,
    private miscAdapter: MiscAdapter
  ) { }

  ngOnInit() {
    this.campaignAdapter.getCustomerId().then((cid) => {
      this.miscAdapter.isCreditAccountNumberApproved(cid.toString()).then((r) => {
        this.paymentType = r ? PaymentType.MediacorpCredit.key : PaymentType.CreditCard.key;
      }).catch((err) => {
        console.log(err);
        this.paymentType = PaymentType.CreditCard.key;
      });
    });
    this.messageService.sendFormTitle(['Complete Payment', false]);
    this.calculateCreativeCostingStats();
    this.loadCreativeDescriptions();
  }

  loadCreativeDescriptions() {
    for (var videoOption of this.selectedVideoOptions) {
      var i: number = 0
      var description = {
        type: '',
        cost: 0,
        quantity: videoOption.quantity * this.selectedLanguage.length
      };
      description.type = videoOption.length + '-sec motion graphics video (' +
        ((videoOption.creative_product_id === 1 || videoOption.creative_product_id === 3) ? 'Client produced' : 'Mediacorp produced') + ')';
      while (i < videoOption.quantity) {
        i++;
        for (var language of this.selectedLanguage) {
          description.cost = description.cost + videoOption.price;
        }
      }
      this.creativeDescriptions.push(description);
    }
  }

  //Calculate all operation related to creative prices (gst amount, creative cost & total cost)
  calculateCreativeCostingStats() {
    this.gstAmount = this.totalPrice * this.gst;
    this.totalCostAfterTax = this.paymentService.calculateTotalAmountAfterTax(this.totalPrice);
  }

  backToList() {
    if (this.backToCampaignId) {
      this.backingToCampaignPage = true;
      this.router.navigate(['campaign/edit', this.backToCampaignId], { queryParams: { "fromCreative": true } }).catch((e) => {
        this.backingToCampaignPage = false;
      });
    } else {
      this.router.navigate([ObjectType.Creative, 'list']);
    }
  }

  backToPreviousPage() {
    this.backToRenameCreative.emit();
  }

  onPaymentSelection(type: string) {
    if (type !== this.paymentType) {
      this.paymentType = type;
    }
  }

  setUpPaymentStatusCheck(orderId: string) {
    let closeModal = this.modal.openModal({
      closeButton: false,
      headerContent: 'Thank you!',
      bodyContent: this.paymentPendingTemplate,
      hideFooterContent: true,
      disabledNonFooterClick: true
    });
    let interval = setInterval(() => {
      this.campaignAdapter.getOrder(orderId).then((payments: CampaignOrder) => {
        if (payments.status === 'PAID') {
          clearInterval(interval);
          closeModal(false);
          this.submitCreatives();
        }
      });
    }, Constants.PAYMENT_STATUS_CHECK_INTERVAL);
  }

  submitCreatives() {
    this.backToList();
    this.modal.confirmation(this.creativeSubmittedTemplate,
      'Thank you! Your payment is being processed.', '', undefined, undefined,
      [{
        label: 'Ok',
        variant: ButtonVariant.PRIMARY
      }]
    );
  }
}
